import { action } from '@ember/object';
import Service from '@ember/service';
import { tracked } from 'tracked-built-ins';

export default class ModalService extends Service {
  @tracked isShownNewOrder = false;
  @action
  toggleNewOrder() {
    this.isShownNewOrder = !this.isShownNewOrder;
  }
  @tracked isShownStocktaking = false;
  @action
  toggleStocktaking() {
    this.isShownStocktaking = !this.isShownStocktaking;
    console.log('Stocktaking modal toggled', this.isShownStocktaking);
  }
}

// Don't remove this declaration: this is what enables TypeScript to resolve
// this service using `Owner.lookup('service:modal')`, as well
// as to check when you pass the service name as an argument to the decorator,
// like `@service('modal') declare altName: ModalService;`.
declare module '@ember/service' {
  interface Registry {
    modal: ModalService;
  }
}
